<template>
  <div>
    <div class="col-md-12">
      <form name="newDocument" @submit.prevent="handleSubmit()">
        <div class="modal-body">
          <label>LastName :</label>
          <input name="LastName" 
                 v-validate="'max:255'"
                 v-model="encodingData.LastName" class="form-control" 
                 :class="{ 'is-invalid': submitted && errors.has('LastName') }" />
          <span v-if="submitted && errors.has('LastName')"
                class="invalid-feedback">{{ errors.first("LastName") }}</span>

          <label>Suffix (Jr, IV) :</label>
          <input name="NameSuffix"
                 v-validate="'max:50'"
                 v-model="encodingData.NameSuffix" class="form-control" 
                 :class="{ 'is-invalid': submitted && errors.has('NameSuffix') }" />
          <span v-if="submitted && errors.has('NameSuffix')"
                class="invalid-feedback">{{ errors.first("NameSuffix") }}</span>

          <label>FirstName :</label>
          <input name="FirstName" 
                 v-validate="'max:255'"
                 v-model="encodingData.FirstName" class="form-control"
                 :class="{ 'is-invalid': submitted && errors.has('FirstName') }" />
          <span v-if="submitted && errors.has('FirstName')"
                class="invalid-feedback">{{ errors.first("FirstName") }}</span>

          <label>MiddleName :</label>

          <input name="MiddleName" 
                 v-validate="'max:255'"
                 v-model="encodingData.MiddleName" class="form-control"
                 :class="{ 'is-invalid': submitted && errors.has('MiddleName') }" />
          <span v-if="submitted && errors.has('MiddleName')"
                class="invalid-feedback">{{ errors.first("MiddleName") }}</span>

          <label>Alias :</label>

          <input name="Alias" 
                 v-validate="'max:200'"
                 v-model="encodingData.Alias" class="form-control"
                 :class="{ 'is-invalid': submitted && errors.has('Alias') }" />
          <span v-if="submitted && errors.has('Alias')"
                class="invalid-feedback">{{ errors.first("Alias") }}</span>

          <label>Birth Country:</label>
          <select name="SourceId" v-model="encodingData.BirthCountry" class="form-control">
            <option value>Select Birth Country</option>
            <option
              v-for="option in countries"
              v-bind:value="option.countryName"
              v-bind:key="option.countryName"
            >{{option.countryName}}</option>
          </select>

          <label>Nationality:</label>
          <select name="SourceId" v-model="encodingData.Nationality" class="form-control">
            <option value>Select Nationality</option>
            <option
              v-for="option in countries"
              v-bind:value="option.countryName"
              v-bind:key="option.countryName"
            >{{option.countryName}}</option>
          </select>

          <label>BirthState:</label>

          <select name="SourceId" v-model="encodingData.BirthState" class="form-control">
            <option value>Select Birth State</option>
            <option
              v-for="option in provinces"
              v-bind:value="option.province"
              v-bind:key="option.province"
            >{{option.province}}</option>
          </select>

          <label>BirthDate :</label>

          <input type="date" name="BirthDate" v-model="encodingData.BirthDate" class="form-control" />

          <label>BirthCity :</label>

          <input type="text" 
                 v-validate="'max:50'"
                 name="BirthCity" v-model="encodingData.BirthCity"
                 class="form-control"
                 :class="{ 'is-invalid': submitted && errors.has('BirthCity') }" />
          <span v-if="submitted && errors.has('BirthCity')"
                class="invalid-feedback">{{ errors.first("BirthCity") }}</span>
                 

          <label>Religion :</label>

          <select name="SourceId" v-model="encodingData.Religion" class="form-control">
            <option value>Select Religion</option>
            <option value="Catholic">Catholic</option>
            <option value="Islam">Islam</option>
            <option value="Protestant">Protestant</option>
            <option value="Buddhism">Buddhism</option>
            <option value="Shintoism">Shintoism</option>
            <option value="Iglesia Ni Cristo">Iglesia Ni Cristo</option>
          </select>

          <label>Gender :</label>

          <select name v-model="encodingData.Sex" class="form-control">
            <option value>Select Gender</option>
            <option value="Male">Male</option>
            <option value="Female">Female</option>
          </select>

          <label>Status :</label>

          <select name v-model="encodingData.Status" class="form-control">
            <option value>Select Status</option>
            <option value="Single">Single</option>
            <option value="Married">Married</option>
            <option value="Separated">Separated</option>
            <option value="Widowed">Widowed</option>
          </select>

          <label>Comments :</label>

          <textarea
            name="Comments"
            v-model="encodingData.Comments"
            class="form-control"
            cols="5"
            rows="5"
          />

          <label>PersonalData :</label>

          <textarea
            name="PersonalData"
            v-model="encodingData.PersonalData"
            class="form-control"
            cols="5"
            rows="5"
          />

          <label>PhysicalDescription :</label>
          <textarea
            name="PhysicalDescription"
            v-model="encodingData.PhysicalDescription"
            class="form-control"
            cols="5"
            rows="5"
          />
        </div>
        <div class="modal-footer">
          <button type="submit" class="btn btn-primary">Update</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>

import {
  authHeader,
  responseCheck,
  notifyHelper,
  EncodeURL,
  DataURL,
  getlocalstorageCountry,
  getlocalstorageProvince,
  formatdate
} from '../../helper'
import instance from '../../helper/http'
export default {
  data() {
    return {
      encodingData: {
        Id: '',
        PersonId: '',
        LastName: '',
        NameSuffix: '',
        FirstName: '',
        MiddleName: '',
        Alias: '',
        BirthCountry: '',
        Nationality: '',
        BirthState: '',
        BirthDate: null,
        BirthCity: '',
        Religion: '',
        Sex: '',
        Status: '',
        Comments: '',
        PersonalData: '',
        PhysicalDescription: ''
      },
      countries: [],
      provinces: []
    }
  },
  props: {
    id: {
      type: String,
      required: true
    }
  },
  created: function() {
    this.getlibs()
  },
  methods: {
    getlibs() {
      
      this.countries = getlocalstorageCountry()
      this.provinces = getlocalstorageProvince()
      
      this.getPerson()
    },
    handleSubmit() {
      let loader = this.$loading.show()
      instance
        .post(EncodeURL + 'updatePerson', this.encodingData, {
          headers: authHeader()
        })
        .then(response => {
          if (response.data.error) {
            loader.hide()
            notifyHelper('error', response.data.message)
          } else {
            loader.hide()
            notifyHelper('success', response.data.message)
            this.$emit('done-edit-person')
          }
        })
        .catch(function (error) {
          loader.hide()
          responseCheck(error.response.status);
        })
    },
    getPerson() {
      
      instance
        .get(DataURL + 'person?personID=' + this.id, {
          headers: authHeader()
        })
        .then(response => {
          if (response.data.error === false) {
            if (response.data.withdata) {
              let data = response.data.data
              this.encodingData.Id = data.id
              this.encodingData.PersonId = data.personId
              this.encodingData.LastName = data.lastName
              this.encodingData.FirstName = data.firstName
              this.encodingData.MiddleName = data.middleName
              this.encodingData.Alias = data.alias
              this.encodingData.BirthCountry = data.birthCountry
              this.encodingData.Nationality = data.nationality
              this.encodingData.BirthState = data.birthState
              this.encodingData.BirthDate = formatdate(data.birthDate)
              this.encodingData.BirthCity = data.birthCity
              this.encodingData.Religion = data.religion
              this.encodingData.Sex = data.sex
              this.encodingData.Status = data.status
              this.encodingData.Comments = data.comments
              this.encodingData.PersonalData = data.personalData
              this.encodingData.PhysicalDescription = data.PhysicalDescription
            }
          }
        })
        .catch(function (error) {
          responseCheck(error.response.status);
        })
    }
  }
}
</script>